import { Fragment, useState } from "react";
import { SiteHeader } from "@/components/header";
import Footer from "@/components/footer/footer";
import ScrollToTop from "@/components/scroll-to-top";
import FloatingContact from "@/components/floating-contact/FloatingContact";
import { ToastContainer } from "react-toastify";
import { Nunito_Sans,Poppins } from "next/font/google";


export const nunito = Nunito_Sans({
  weight: ["200", "300", "400", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const Poppin = Poppins({
  weight: ["200", "300", "400", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});


const LayoutFive = ({ children, navPositionClass, topbar, recentBlogs }) => {
  const [toggleClassName, SetToggleClassName] = useState(false);

  function toggleClassNameInBody() {
    SetToggleClassName((toggleClassName) => !toggleClassName);
  }

  return (
    <Fragment>
      <style jsx global>{`
        html,
        body {
          font-family: ${nunito.style.fontFamily};
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        .h1,
        .h2,
        .h3,
        .h4,
        .h5,
        .h6 {
          font-family: ${Poppin.style.fontFamily};
        }
      `}</style>
      <ToastContainer />
      <div
        className={`body-wrapper ${toggleClassName ? "ltn__utilize-open" : ""}`}
      >
        <SiteHeader topbar={topbar} />
        <main id="main-content" role="main" tabIndex={-1}>
          {children}
        </main>
        <Footer recentBlogs={recentBlogs} />
        <FloatingContact />
        <ScrollToTop />
      </div>
    </Fragment>
  );
};

export default LayoutFive;
